var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/notes and task/outline/task 01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6667 4.94594H19.8333C22.4107 4.94594 24.5 7.06265 24.5 9.67375V21.4933C24.5 24.1044 22.4107 26.2211 19.8333 26.2211H8.16667C5.58934 26.2211 3.5 24.1044 3.5 21.4933V9.67375C3.5 7.06265 5.58934 4.94594 8.16667 4.94594H9.33333M18.6667 4.94594C18.6667 6.25149 17.622 7.30985 16.3333 7.30985H11.6667C10.378 7.30985 9.33333 6.25149 9.33333 4.94594M18.6667 4.94594C18.6667 3.64039 17.622 2.58203 16.3333 2.58203H11.6667C10.378 2.58203 9.33333 3.64039 9.33333 4.94594M14 12.0377H18.6667M14 16.7655H18.6667M14 21.4933H18.6667",
    stroke: "#A461D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1099",
    d: "M11.0833 12.0374C11.0833 12.6902 10.561 13.2194 9.91667 13.2194C9.27233 13.2194 8.75 12.6902 8.75 12.0374C8.75 11.3846 9.27233 10.8555 9.91667 10.8555C10.561 10.8555 11.0833 11.3846 11.0833 12.0374Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1100",
    d: "M11.0833 16.7679C11.0833 17.4207 10.561 17.9498 9.91667 17.9498C9.27233 17.9498 8.75 17.4207 8.75 16.7679C8.75 16.1151 9.27233 15.5859 9.91667 15.5859C10.561 15.5859 11.0833 16.1151 11.0833 16.7679Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1101",
    d: "M11.0833 21.4945C11.0833 22.1472 10.561 22.6764 9.91667 22.6764C9.27233 22.6764 8.75 22.1472 8.75 21.4945C8.75 20.8417 9.27233 20.3125 9.91667 20.3125C10.561 20.3125 11.0833 20.8417 11.0833 21.4945Z",
    fill: "#A461D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/service-icon.b15455c8b620900cc0de19f6e87f144e.svg";
export { ForwardRef as ReactComponent };